// console.log("teste de console");

jQuery(document).ready(function($) {

  // MODAL
  $("button[data-modal], a[data-modal]").on('click', function(event) {
      event.preventDefault();

      var id = "#" + $(this).data("modal"),
          $closeModal = $(".btn-close-modal"),
          $this = $(this),
          $body = $(this).parents("body");

      $(id).addClass('active');
      $body.addClass('show-modal');

      $this.parent().siblings().children().removeClass('active');
      $this.addClass('active');

      if ($body.hasClass('show-modal')) {
          $closeModal.on('click', function(event) {
              event.preventDefault();
              $body.removeClass('show-modal');
              $(id).removeClass('active');
              $this.removeClass('active');

              $( id + " .info .pdf" ).hide();
          });
      }

      // adiciona imagens do cartao no modal
      var carta = $(this).find(".frente img").attr("src");
      var timeBase = $(this).find(".atras img").attr("src");
      $(id).find(".carta img").attr("src", carta);
      $(id).find(".time-base img").attr("src", timeBase);
      // fim | adiciona imagens do cartao no modal

      // CHECA SE É A RESOLUCAO DE SMARTPHONE
      var $window = $(window);
      function checkWidth() {
        var windowsize = $window.width();
        if (windowsize < 768) {
          $( id + " .time-base .pdf" ).appendTo( ".info" );
        }
      }
      checkWidth();
      $(window).resize(checkWidth);
      // FIM | CHECA SE É A RESOLUCAO DE SMARTPHONE
  });

  function close() {
      $(".modal-default").removeClass('active');
      $("body").removeClass('show-modal');
  }
  // FIM | MODAL


  // if( /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
  //  $( ".modal-content .time-base .pdf" ).appendTo( ".info" );
  // }

});
